import { render, staticRenderFns } from "./PathCrumb.vue?vue&type=template&id=583de168&scoped=true"
import script from "./PathCrumb.vue?vue&type=script&lang=js"
export * from "./PathCrumb.vue?vue&type=script&lang=js"
import style0 from "./PathCrumb.vue?vue&type=style&index=0&id=583de168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583de168",
  null
  
)

export default component.exports